module.exports = __webpack_public_path__ + "ag.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ag.svg
// module id = 664
// module chunks = 0